import { AppState } from '@/types';

export const createPrizeActions = (state: AppState, dispatch: any) => {
  const redeemPrize = (pointCost: number, prizeName: string) => {
    dispatch({ type: 'REDEEM_PRIZE', payload: { pointCost, prizeName } });
  };

  return {
    redeemPrize,
  };
};